/* src/app/new-shared/components/modals/mfa/components/configure-mfa/configure-mfa-popup.component.scss */
@media (min-width: 760px) {
  .modal-configure-mfa {
    max-width: 760px;
    margin: 30px auto;
    min-width: 550px;
  }
}
.configure-mfa-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2.52rem;
}
.configure-mfa-panel .content {
  font-size: 1.54rem;
  color: gray;
  text-align: center;
  font-weight: 600;
  margin-bottom: 2.52rem;
  width: 100%;
}
.configure-mfa-panel .second-step-content {
  font-size: 1.54rem;
  color: gray;
  font-weight: 600;
  width: 100%;
}
.configure-mfa-panel .action-link {
  text-align: right;
  margin-top: auto;
}
.configure-mfa-panel form {
  text-align: center;
}
.header {
  justify-content: space-between;
  font-weight: bold;
}
.horizontal-button-group {
  display: flex;
  justify-content: space-between;
  margin-left: 2.52rem;
  margin-right: 2.52rem;
  padding-top: 2.52rem;
  margin-bottom: 1.4rem;
  margin-top: 1.4rem;
}
.horizontal-button-group g-button {
  width: auto;
}
.separator {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  align-self: center;
  margin-bottom: 2.52rem;
}
.separator:before {
  position: absolute;
  display: block;
  content: "";
  height: 2px;
  width: 100%;
  background: rgb(210.5319148936, 130.9574468085, 214.0425531915);
}
.separator--text {
  background: white;
  z-index: 2;
  padding: 0 1.4rem;
  font-weight: 600;
  color: #67236A;
  font-size: 1.694rem;
  text-transform: uppercase;
}
.chevron-icon {
  font-size: 1.2rem;
}
.image {
  display: flex;
  justify-content: center;
  margin-top: 2.52rem;
  margin-bottom: 1.4rem;
}
.secret-key {
  display: flex;
  justify-content: center;
  margin-bottom: 2.52rem;
  flex-wrap: wrap;
}
.secret-key .box {
  margin: 8px;
  font-weight: bold;
  border: 1px solid #c5c5c5;
  padding: 8px;
}
.secret-key div {
  margin-bottom: inherit;
  margin-top: 1.4rem;
}
.mfa-token-input {
  max-width: fit-content;
  display: inline-flex;
}
.mfa-token-input input {
  text-align: center;
}
.first-error {
  color: red;
  font-weight: 600;
  margin-left: 2.52rem;
  text-align: left;
}
/*# sourceMappingURL=configure-mfa-popup.component.css.map */
